/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Sign_In_UnavailableInputs */



/**
* | output |
* | --- |
* | "Signing in is only available on the shared link for this canvas." |
*
* @param {Canvas_Sign_In_UnavailableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_sign_in_unavailable = /** @type {((inputs?: Canvas_Sign_In_UnavailableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Sign_In_UnavailableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Anmeldung ist nur über den geteilten Link dieses Canvas möglich.")
	return /** @type {LocalizedString} */ ("Signing in is only available on the shared link for this canvas.")
});